import ajax from '@/resources/myApi';
import { AccountNoteDto } from '@/dto';

export const AccountNoteService = {
  getAll,
  create,
  update,
  deleteNote
};

async function getAll(accountId) {
  try {
    const { data } = await ajax.get(`api/accountnote/${accountId}`, {
      name: 'notes'
    });
    return data.map(item => new AccountNoteDto(item)).reverse();
  } catch {}
}


async function create(accountId, note) {
  try {
    await ajax.post('api/accountnote', {
      name: 'documents',
      body: {
        accountId,
        note
      }
    });
  } catch {}
}

async function update(noteId, note) {
  try {
    await ajax.put(`api/accountnote/${noteId}`, {
      name: 'documents',
      body: note
    });
  } catch {}
}

async function deleteNote(note) {
  try {
    await ajax.delete(`api/accountnote/${note.id}`, {
      name: 'documents'
    });
  } catch {}
}
